import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';
import { PaletteConfig } from 'services/configuration';

export const useStyles = (props: {
  height?: number;
  width?: number;
  flow: string | undefined;
  palette: PaletteConfig | undefined;
}) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      overlayContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignContent: 'center',
        borderRadius: '8px',
        backgroundColor: props.flow === 'fair' ? props.palette?.accent : 'white',
        padding: '56px 45px 0px 45px',
        justifyContent: 'center',
        boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.2)',
        width: props.width ? props.width : 1160,
        height: props.height ? props.height : 749,
        [theme.breakpoints.down('lg')]: {
          width: 1010
        },
        [theme.breakpoints.only('lg')]: {
          height: props.height ? props.height : 776
        }
      },
      cancelButton: {
        maxWidth: 470,
        minWidth: 450,
        [theme.breakpoints.down('lg')]: {
          maxWidth: 460,
          minWidth: 420
        },
        [theme.breakpoints.only('lg')]: {
          width: 418
        }
      },
      confirmButton: {
        maxWidth: 470,
        minWidth: 450,
        [theme.breakpoints.down('lg')]: {
          maxWidth: 460,
          minWidth: 420
        },
        [theme.breakpoints.only('lg')]: {
          width: 418
        }
      }
    })
  );
